@if (!isFinished()) {
    <div class="container pt-3 fade-in-left" id="centerFrame">
        <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
            <a [routerLink]="['/condiciones']">
                <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
            </a>

            <div class="p-2 flex-grow-1 pl-2">
                <h1 class="text-dark text-center">Compra en {{ x_nombre_fantasia_comercio }}</h1>
            </div>

            <div class="p-2 pl-2 help" (click)="toggleHelp()">
                <i class="bi bi-info-circle"></i>
            </div>
        </div>

        <!-- Tooltip ayuda -->
        @if (helpOpen()) {
            <div class="row m-3 p-3 align-items-center" id="tooltip-pwa" style="display:flex;">
                <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
                <div class="col">{{ helpText() }}</div>
                <div class="col-auto" (click)="toggleHelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
            </div>
        }

        <div class="row mb-3 mt-3 p-3 text-start">
            <div class="col">
                <div class="col">
                    <span class="order-title fw-bold">PEDIDO</span>
                </div>

                <div class="col">
                    @if (x_nombre_cliente) {
                    <span class="fw-bold">Para {{ x_nombre_cliente }}</span>
                    } @else {
                    <span class="fw-bold">Para Nombre Apellido</span>
                    }
                </div>
            </div>

            <div class="col-auto d-flex align-items-center pe-lg-4">
                <i class="bi bi-receipt d-block"></i>
            </div>

            <hr class="divisor mt-4 mb-1" />

            <div class="mt-1 resultSearch">
                <div class="hiddenList">
                    <div class="row p-3 align-items-center">
                        <div class="col p-0">
                            <div class="row">
                                <div class="col-auto text-title-item pe-0">{{ x_nombre_fantasia_comercio }}</div>
                            </div>
                            <div class="col-10 text-detail-item">{{ x_domicilio_comercio }}</div>
                        </div>
                        <div class="col-auto"></div>
                    </div>
                </div>
            </div>

            <hr class="divisor mt-1 mb-1" />

            <div class="mt-1 resultSearch">
                @for (vademecumSel of vademecumsSeleccionados; track vademecumSel.id_vademecum) {
                    <div class="hiddenList">
                        <div class="row p-3 pb-0 align-items-top">
                            <div class="col-8 col-sm-10 p-0 me-sm-0 pe-2">
                                <div class="row">
                                    <div class="col-auto text-title-item pe-0">{{ vademecumSel.x_nombre }}</div>
                                    <div class="col-auto text-title-item pe-0 text-success"></div>
                                </div>
                                <div class="col-10 text-detail-item">
                                    {{ vademecumSel.nombreLaboratorio }} - {{ vademecumSel.x_presentacion }}
                                </div>
                            </div>

                            <div class="col-4 col-sm-2 p-0 ps-4 ps-sm-5">
                                <div class="col-12 text-end text-title-item"
                                    [ngClass]="(vademecumSel.n_porcentaje_descuento ?? 0) > 0 ? 'text-primary' : 'text-success'">
                                    <b>
                                        {{
                                        (vademecumSel.n_porcentaje_descuento ?? 0) > 0
                                        ? ((vademecumSel.n_precio! * (1 - vademecumSel.n_porcentaje_descuento! / 100)) |
                                        currency:'ARS')
                                        : (vademecumSel.n_precio | currency:'ARS')
                                        }}
                                    </b>
                                </div>

                                @if ((vademecumSel.n_porcentaje_descuento ?? 0) > 0) {
                                <div class="col-12 text-end text-title-item d-flex flex-row-reverse">
                                    <div
                                        class="text-title-item bg-primary text-light discount-shop d-flex align-items-center w-auto ps-1 pe-1">
                                        {{ vademecumSel.n_porcentaje_descuento }}% OFF
                                    </div>
                                </div>
                                <div class="col-12 text-end text-detail-item text-danger text-decoration-line-through">
                                    <b>{{ vademecumSel.n_precio | currency:'ARS' }}</b>
                                </div>
                                }

                                <div class="row pt-2 d-flex align-items-top flex-row-reverse">
                                    <div class="col-4 col-sm-2 col-md-4">
                                        <div class="add-button d-flex"
                                            (click)="addQtyVademecumCart(vademecumSel.id_vademecum!)">
                                            <i class="bi bi-plus"></i>
                                        </div>
                                    </div>
                                    <div class="col-4 col-sm-2 col-md-4">
                                        <div class="quantity-button quantity text-center">{{ vademecumSel.n_cantidad }}</div>
                                    </div>
                                    <div class="col-4 col-sm-2 col-md-4">
                                        <div class="remove-button remove"
                                            (click)="removeVademecumCart(vademecumSel.id_vademecum!)">
                                            <i class="align-middle bi bi-dash"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="divisor mt-4 mb-1" />
                    </div>
                }

                @for (productoSel of productosSeleccionados; track productoSel.id_producto) {
                    <div class="hiddenList">
                        <div class="row p-3 pb-0 align-items-top">
                            <div class="col-8 col-sm-10 p-0 me-sm-0 pe-2">
                                <div class="row">
                                    <div class="col-12 text-title-item pe-0">{{ productoSel.x_nombre }}</div>
                                </div>
                                <div class="col-12 text-detail-item">SKU: {{ productoSel.x_sku }}</div>
                            </div>

                            <div class="col-4 col-sm-2 p-0 ps-4 ps-sm-5">
                                <div class="col-12 text-end text-title-item"
                                    [ngClass]="(productoSel.n_porcentaje_descuento ?? 0) > 0 ? 'text-primary' : 'text-success'">
                                    <b>
                                        {{
                                        (productoSel.n_porcentaje_descuento ?? 0) > 0
                                        ? ((productoSel.n_precio! * (1 - productoSel.n_porcentaje_descuento! / 100)) |
                                        currency:'ARS')
                                        : (productoSel.n_precio | currency:'ARS')
                                        }}
                                    </b>
                                </div>

                                @if ((productoSel.n_porcentaje_descuento ?? 0) > 0) {
                                    <div class="col-12 text-end text-title-item d-flex flex-row-reverse">
                                        <div
                                            class="text-title-item bg-primary text-light discount-shop d-flex align-items-center w-auto ps-1 pe-1">
                                            {{ productoSel.n_porcentaje_descuento }}% OFF
                                        </div>
                                    </div>
                                    <div class="col-12 text-end text-detail-item text-danger text-decoration-line-through">
                                        <b>{{ productoSel.n_precio | currency:'ARS' }}</b>
                                    </div>
                                }

                                <div class="row d-flex pt-2 d-flex align-items-top flex-row-reverse">
                                    <div class="col-4 col-sm-2 col-md-4">
                                        <div class="add-button d-flex" (click)="addQtyProductoCart(productoSel.id_producto!)">
                                            <i class="bi bi-plus"></i>
                                        </div>
                                    </div>
                                    <div class="col-4 col-sm-2 col-md-4">
                                        <div class="quantity-button quantity text-center">{{ productoSel.n_cantidad }}</div>
                                    </div>
                                    <div class="col-4 col-sm-2 col-md-4">
                                        <div class="remove-button remove"
                                            (click)="removeProductoCart(productoSel.id_producto!)">
                                            <i class="align-middle bi bi-dash"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="divisor mt-4 mb-1" />
                    </div>
                }
            </div>

            <div class="row pe-0">
                <div class="col-9 mb-0 mt-0 p-3 text-start">
                    <div class="col-12 fw-bold">Forma de entrega</div>
                    <div class="col-12 text-detail-item">{{ x_forma_entrega }}</div>
                </div>
                <a [routerLink]="['/condiciones']"
                    class="col-3 mb-0 mt-0 p-3 text-end d-flex align-items-center pe-2 cursor-pointer">
                    <div class="col-12 fw-bold"><i class="bi bi-arrow-left-right"></i></div>
                </a>
            </div>

            <hr class="divisor mt-0 mb-1" />

            <div class="row pe-0">
                <div class="col-9 mb-0 mt-0 p-3 text-start">
                    <div class="col-12 fw-bold">Forma de pago</div>
                    <div class="col-12 text-detail-item">{{ x_forma_pago }}</div>
                </div>
                <a [routerLink]="['/condiciones']"
                    class="col-3 mb-0 mt-0 p-3 text-end d-flex align-items-center pe-2 cursor-pointer">
                    <div class="col-12 fw-bold"><i class="bi bi-arrow-left-right"></i></div>
                </a>
            </div>

            <hr class="divisor mt-0 mb-1" />

            @if (n_ahorro() > 0) {
                <div class="row mb-0 mt-0 p-3 pb-0 text-start pe-0">
                    <div class="col-8 fw-bold">Subtotal</div>
                    <div class="col-4 fw-bold text-end pe-0">{{ n_total() | currency:'ARS' }}</div>
                </div>
                <div class="row mb-0 mt-0 p-3 pb-0 text-start pe-0">
                    <div class="col-8 fw-bold">Ahorro</div>
                    <div class="col-4 fw-bold text-end text-success pe-0">-{{ n_ahorro() | currency:'ARS' }}</div>
                </div>
            }

            <div class="row mb-0 mt-0 p-3 text-start pe-0">
                <div class="col-8 fw-bold">TOTAL</div>
                <div class="col-4 fw-bold text-end pe-0">
                    {{ totalFinal | currency:'ARS' }}
                </div>
            </div>

            <hr class="divisor mt-1 mb-4" />

            <div class="row mb-0 mt-3 p-3 text-start">
                <div class="form-switch ps-3 pe-3 mb-0 mt-0">
                    <p class="col text-center tyc">
                        Al continuar aceptás los <a [routerLink]="['/terminos-condiciones', 2]" class="tyclink">Términos y condiciones</a>
                    </p>
                </div>
            </div>

            @if (error().length > 0) {
                <div class="alert alert-danger mt-2" role="alert">
                    <small>{{ error() }}</small>
                </div>
            }

            <div class="row fade-in pt-0 pb-3 mb-3 m-2">
                <div class="d-grid mt-0 mb-5">
                    <button type="button" class="btn btn-primary btn-lg mt-0" (click)="finalizaOrder()"
                        [disabled]="loading()">
                        {{ loading() ? 'Cargando...' : 'Enviar pedido' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div class="container mt-5 fade-in-left" id="centerFrameTwo">
        <div class="row p-3 mb-3 mt-5 align-items-center">
            <div class="mt-5">
                <div class="row form-switch ps-0 mb-3">
                    <div class="col text-center sucess-text mt-5 mb-5">
                        <b>¡Tu solicitud fue enviada<br><span class="bluetext"><strong>al comercio!</strong></span></b>
                    </div>
                </div>
            </div>

            <div class="d-grid mt-3 mb-2">
                <button [routerLink]="['/pedidos']" type="button" class="btn btn-primary btn-lg mt-0">Volver</button>
            </div>
        </div>
    </div>
}